import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';

import Paper from '~/components/Paper';
import GridItem from '~/components/GridItem';
import GridContainer from '~/components/GridContainer';
import InputShow from '~/components/InputShow';

import { genresOptions } from '~/config/constants';

import MedicalRecord from './MedicalRecord';

const MedicalRecords = ({ idClient, record }) => {
  const { t } = useTranslation();

  return (
    <>
      <Paper
        Icon={AssignmentIndIcon}
        iconColor="blue"
        title={t('medical_records.extras.user_data')}
      >
        <GridContainer>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputShow
              label={t('person.attributes.name')}
              value={record.get('name')}
            />
          </GridItem>

          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputShow
              label={t('person.attributes.email')}
              value={record.get('email')}
            />
          </GridItem>

          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputShow
              label={t('person.attributes.cell_phone')}
              value={record.get('cell_phone')}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputShow
              label={t('person.attributes.cpf')}
              value={record.get('cpf')}
              type="cpf"
            />
          </GridItem>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputShow
              label={t('person.attributes.born_date')}
              value={
                record.get('born_date')
                  ? moment(record.get('born_date')).format('LL')
                  : ''
              }
            />
          </GridItem>
          <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
            <InputShow
              label={t('person.attributes.years_old')}
              value={
                record.get('born_date')
                  ? `${moment().diff(record.get('born_date'), 'years')} ${t(
                      'person.attributes.years_old'
                    )}`
                  : ''
              }
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputShow
              label={t('person.attributes.gender')}
              value={genresOptions[ record.get('gender') ]}
            />
          </GridItem>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputShow
              label={t('person.attributes.cns')}
              value={record.get('cns')}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputShow
              type="object"
              digObject={['postal_code']}
              label={t('person.attributes.postal_code')}
              value={record.get('address')}
            />
          </GridItem>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputShow
              type="object"
              digObject={['name']}
              label={t('person.attributes.city')}
              value={record.get('address')?.city}
            />
          </GridItem>
          <GridItem xs={12} sm={4} md={4} lg={4} xl={4}>
            <InputShow
              type="object"
              digObject={['neighborhood']}
              label={t('person.attributes.neighborhood')}
              value={record.get('address')}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={10} md={10} lg={10} xl={10}>
            <InputShow
              type="object"
              digObject={['street']}
              label={t('person.attributes.street')}
              value={record.get('address')}
            />
          </GridItem>
          <GridItem xs={12} sm={2} md={2} lg={2} xl={2}>
            <InputShow
              type="object"
              digObject={['number']}
              label={t('person.attributes.number')}
              value={record.get('address')}
            />
          </GridItem>
        </GridContainer>
      </Paper>
      <MedicalRecord idClient={idClient} name={record.get('name')}/>
    </>
  );
};

export default React.memo(MedicalRecords);
